module.exports = __webpack_public_path__ + "static/assets/1789331966536d03c17a76b97a1364d6.svg";